import React from 'react';
import './style.css';
import { Checkbox, CheckboxGroup } from 'react-checkbox-group';

const Checkboxes = props => {
  return (
    <div className="App-checkbox">
      <form onSubmit={props.handleSubmit} className="form-check">
        <CheckboxGroup
          name="checkboxQuestion"
          value={props.value}
          onChange={props.handleChange}
          checkboxDepth={3}
        >
          {props.answers.map(answer => (
            <div key={answer.uuid} className="form-check">
              <label className="custom-control custom-checkbox">
                <Checkbox
                  className="custom-control-input"
                  value={answer.uuid}
                />
                <span className="custom-control-indicator" />
                <span className="custom-control-description">
                  {answer.answer}
                </span>
              </label>
            </div>
          ))}
        </CheckboxGroup>
      </form>
    </div>
  );
};

export default Checkboxes;



// WEBPACK FOOTER //
// ./src/preference/components/Checkbox/index.js